(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56565],{

/***/ 56565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhyUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/variables/compareCRMPricesVariables.module.scss
var compareCRMPricesVariables_module = __webpack_require__(31754);
var compareCRMPricesVariables_module_default = /*#__PURE__*/__webpack_require__.n(compareCRMPricesVariables_module);
;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/box.tsx


function Box() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "92",
        height: "89",
        fill: "none",
        viewBox: "0 0 92 89",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_299_428)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FFF1E7",
                    d: "M91.994 42.69c-.05-2.64-.486-5.273-.859-7.878a23.535 23.535 0 00-.733-3.426c-.683-2.282-1.696-4.48-2.656-6.646a22.346 22.346 0 00-1.34-2.56c-1.225-2.015-2.751-3.86-4.19-5.706a26.497 26.497 0 00-4.13-4.234c-1.82-1.49-3.662-2.994-5.62-4.303-2.916-1.949-6.22-3.252-9.446-4.564a35.882 35.882 0 00-6.489-1.917C54.03.96 51.473.663 48.95.352a45.979 45.979 0 00-3.322-.288 41.493 41.493 0 00-6.819.161c-3.705.423-7.507.79-10.987 2.241-2.231.93-4.545 1.796-6.637 3.043-1.49.89-2.825 1.978-4.193 3.043-2.218 1.733-4.31 3.461-6.072 5.68-2.096 2.636-4.234 5.297-5.748 8.334-1.074 2.155-1.976 4.412-2.828 6.66-.353.93-.654 1.878-.902 2.842a27.5 27.5 0 00-.58 2.918C.504 37.438.076 39.943.01 42.44c-.025.95.006 1.901.093 2.848a64.836 64.836 0 001.024 7.32 13.094 13.094 0 003.066 5.9 13.005 13.005 0 004.811 4.467c.661.428 1.359.796 2.084 1.1.231.863.51 1.711.836 2.542.887 2.247 1.726 4.64 2.992 6.726.618 1.018 1.388 1.942 2.106 2.891.717.95 1.449 2.01 2.317 2.876 1.329 1.325 2.916 2.411 4.4 3.535.427.328.872.63 1.333.906.43.252.872.483 1.325.69 1.759.81 3.548 1.598 5.364 2.275a30.714 30.714 0 006.239 1.534c3.533.519 7.053 1.075 10.629.934a35.635 35.635 0 003.157-.279c2.47-.324 4.98-.58 7.416-1.148 3.447-.804 6.744-2.269 9.94-3.757a27.962 27.962 0 005.298-3.243c1.894-1.464 3.887-2.882 5.587-4.592 1.7-1.71 3.116-3.73 4.538-5.645a21.027 21.027 0 001.772-2.816c1.147-2.212 2.078-4.564 2.933-6.901a33.842 33.842 0 001.586-6.39c.59-3.781 1.208-7.676 1.137-11.524z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#51378E",
                clipPath: "url(#clip1_299_428)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.897 64.981H26.883c-1.662 0-1.862-.185-1.864-1.78 0-9.385 0-18.77-.019-28.154a2.097 2.097 0 01.95-1.854c3.276-2.46 6.502-4.98 9.803-7.403a4.065 4.065 0 012.23-.755c9.156-.05 18.312-.033 27.45-.03 1.561 0 1.744.184 1.744 1.76 0 8.607.021 17.212-.033 25.819a3.914 3.914 0 01-.78 2.2c-2.406 3.115-4.93 6.145-7.357 9.234a2.37 2.37 0 01-2.094.982c-5.006-.038-10.011-.019-15.016-.019zM27.132 35.566v27.269h29.466V35.566H27.132zm31.596 25.02l.258.111c1.967-2.457 3.951-4.91 5.886-7.388.234-.297.274-.795.274-1.2.016-7.482.016-14.958 0-22.428 0-.278-.058-.559-.115-1.076-1.955 1.962-3.719 3.777-5.538 5.535a2.447 2.447 0 00-.789 1.948c.026 7.826.017 15.652.017 23.478l.007 1.02zM44.625 33.416h6.773c1.953 0 4.123.496 5.796-.191 1.674-.688 2.853-2.572 4.243-3.926.678-.662 1.343-1.34 2.2-2.198h-11.43a1.202 1.202 0 00-.73.26c-2.2 1.933-4.385 3.883-6.852 6.055zm3.99-6.313c-3.788 0-7.258-.018-10.728.026-.413 0-.874.285-1.226.552-2.214 1.655-4.404 3.343-6.597 5.027-.218.168-.406.376-.763.701 4.055 0 7.874 0 11.694-.011.307-.004.603-.11.843-.3 2.193-1.908 4.364-3.85 6.778-5.997v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.99 39.735h4.696c.704 0 1.397.103 1.432.992.038.968-.671 1.103-1.434 1.103h-9.617c-.704 0-1.408-.096-1.432-.989-.037-.97.672-1.103 1.435-1.103l4.92-.003z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_299_428",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H92V89H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_299_428",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H42.182V40H0z",
                            transform: "translate(25 25)"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var box = (Box);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/watch.tsx


function Watch() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "92",
        height: "89",
        fill: "none",
        viewBox: "0 0 92 89",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_299_427)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FFF1E7",
                    d: "M91.994 42.69c-.05-2.64-.486-5.273-.859-7.878a23.535 23.535 0 00-.733-3.426c-.683-2.282-1.696-4.48-2.656-6.646a22.346 22.346 0 00-1.34-2.56c-1.225-2.015-2.751-3.86-4.19-5.706a26.497 26.497 0 00-4.13-4.234c-1.82-1.49-3.662-2.994-5.62-4.303-2.916-1.949-6.22-3.252-9.446-4.564a35.882 35.882 0 00-6.489-1.917C54.03.96 51.473.663 48.95.352a45.979 45.979 0 00-3.322-.288 41.493 41.493 0 00-6.819.161c-3.705.423-7.507.79-10.987 2.241-2.231.93-4.545 1.796-6.637 3.043-1.49.89-2.825 1.978-4.193 3.043-2.218 1.733-4.31 3.461-6.072 5.68-2.096 2.636-4.234 5.297-5.748 8.334-1.074 2.155-1.976 4.412-2.828 6.66-.353.93-.654 1.878-.902 2.842a27.5 27.5 0 00-.58 2.918C.504 37.438.076 39.943.01 42.44c-.025.95.006 1.901.093 2.848a64.836 64.836 0 001.024 7.32 13.094 13.094 0 003.066 5.9 13.005 13.005 0 004.811 4.467c.661.428 1.359.796 2.084 1.1.231.863.51 1.711.836 2.542.887 2.247 1.726 4.64 2.992 6.726.618 1.018 1.388 1.942 2.106 2.891.717.95 1.449 2.01 2.317 2.876 1.329 1.325 2.916 2.411 4.4 3.535.427.328.872.63 1.333.906.43.252.872.483 1.325.69 1.759.81 3.548 1.598 5.364 2.275a30.714 30.714 0 006.239 1.534c3.533.519 7.053 1.075 10.629.934a35.635 35.635 0 003.157-.279c2.47-.324 4.98-.58 7.416-1.148 3.447-.804 6.744-2.269 9.94-3.757a27.962 27.962 0 005.298-3.243c1.894-1.464 3.887-2.882 5.587-4.592 1.7-1.71 3.116-3.73 4.538-5.645a21.027 21.027 0 001.772-2.816c1.147-2.212 2.078-4.564 2.933-6.901a33.842 33.842 0 001.586-6.39c.59-3.781 1.208-7.676 1.137-11.524z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#51378E",
                clipPath: "url(#clip1_299_427)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27.994 44.965c.046 9.525 7.263 16.995 16.078 17.895 10.22 1.044 18.295-6.312 19.643-14.98a17.794 17.794 0 00-2.23-11.954c-.073-.128-.16-.252-.227-.384-.279-.553-.232-1.073.313-1.407.594-.37 1.164-.179 1.43.416.853 1.924 1.905 3.81 2.402 5.83 2.81 11.443-5.007 22.806-16.656 24.43-11.243 1.564-21.553-6.58-22.642-17.881a19.95 19.95 0 0117.977-21.814c4.291-.424 8.279.508 12.002 2.648.128.075.259.147.38.233.503.346.739.806.412 1.373-.347.599-.866.624-1.467.357-1.43-.654-2.82-1.446-4.312-1.897-11.494-3.497-23.071 5.132-23.104 17.135z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M31.788 44.3h1.825v1.37h-1.682c-.37 2.394 1.35 6.667 3.537 8.823l1.124-1.457c.485.537.77.855 1.073 1.195l-1.173 1.237c1.788 2.045 6.106 3.835 8.772 3.619v-1.715h1.359c.029.572.057 1.152.088 1.803 3.41-.18 6.272-1.418 8.813-3.639l-1.327-1.407c.318-.292.619-.57.962-.883l1.355 1.292c2.22-2.52 3.471-5.383 3.651-8.8l-1.829-.113V44.33h1.822c-.014-1.979-.536-3.72-1.296-5.407-.11-.243-.238-.479-.358-.715-.286-.576-.178-1.083.385-1.378.59-.315 1.146-.136 1.412.482.506 1.172 1.073 2.337 1.392 3.564 2.766 10.737-5.543 20.882-16.63 20.362-8.11-.38-14.924-7.175-15.328-15.284-.418-8.373 5.471-15.76 13.59-17.026a16.323 16.323 0 0110.223 1.654c.536.28.894.705.654 1.282-.134.317-.55.608-.893.716-.25.071-.61-.165-.895-.306-1.788-.864-3.635-1.43-5.721-1.472v1.804H45.34l-.088-1.788c-3.406.163-6.258 1.415-8.816 3.632l1.339 1.416-1.039.917-1.137-1.51c-2.366 2.681-3.617 5.544-3.812 9.027z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M46.01 43.535c4.482-4.483 8.904-8.906 13.324-13.33l2.022-2.024c.47-.472 1.003-.715 1.561-.191.59.558.381 1.117-.127 1.625-5.31 5.307-10.62 10.611-15.93 15.914-.632.629-1.126.622-1.767-.013-1.948-1.927-3.88-3.871-5.824-5.804-.511-.51-.726-1.089-.16-1.632.568-.544 1.134-.277 1.635.227 1.53 1.546 3.072 3.079 4.613 4.615.202.209.42.398.653.613z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_299_427",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H92V89H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_299_427",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H39.966V40H0z",
                            transform: "translate(26 25)"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var watch = (Watch);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/hand.tsx


function Hand() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "92",
        height: "90",
        fill: "none",
        viewBox: "0 0 92 90",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF1E7",
                d: "M91.992 42.698c-.05-2.642-.486-5.274-.859-7.878a23.535 23.535 0 00-.734-3.427c-.682-2.282-1.696-4.48-2.655-6.645a22.346 22.346 0 00-1.341-2.561c-1.224-2.014-2.75-3.86-4.19-5.705a26.527 26.527 0 00-4.13-4.235c-1.82-1.49-3.661-2.994-5.619-4.302-2.917-1.95-6.22-3.253-9.447-4.565a35.88 35.88 0 00-6.488-1.917C54.027.966 51.47.671 48.946.36A45.974 45.974 0 0045.625.07a41.492 41.492 0 00-6.82.162c-3.704.423-7.507.79-10.986 2.24-2.231.93-4.546 1.796-6.637 3.044-1.49.89-2.825 1.977-4.194 3.042-2.217 1.733-4.309 3.462-6.071 5.68-2.096 2.637-4.234 5.298-5.748 8.334-1.074 2.155-1.976 4.413-2.829 6.66-.352.93-.653 1.878-.902 2.842a27.5 27.5 0 00-.58 2.918c-.355 2.453-.784 4.957-.85 7.455-.024.95.007 1.902.093 2.848a64.834 64.834 0 001.024 7.32 13.094 13.094 0 003.066 5.9 13.006 13.006 0 004.812 4.467 13.26 13.26 0 002.084 1.1c.23.863.51 1.712.836 2.542.887 2.248 1.726 4.64 2.992 6.727.618 1.018 1.388 1.941 2.105 2.89.717.95 1.45 2.01 2.317 2.876 1.33 1.325 2.917 2.412 4.401 3.536.426.328.871.63 1.332.905.43.253.872.483 1.325.69 1.76.81 3.549 1.598 5.365 2.275a30.717 30.717 0 006.238 1.534c3.534.519 7.054 1.076 10.63.934a35.67 35.67 0 003.157-.278c2.47-.324 4.98-.58 7.416-1.149 3.446-.803 6.744-2.268 9.939-3.756a27.96 27.96 0 005.299-3.244c1.894-1.464 3.886-2.882 5.587-4.592 1.7-1.71 3.115-3.73 4.538-5.644a21.036 21.036 0 001.771-2.817c1.147-2.212 2.078-4.564 2.934-6.9a33.85 33.85 0 001.586-6.39c.59-3.782 1.207-7.677 1.137-11.524z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_299_426)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#51378E",
                    d: "M39.402 38.463c2.017-.98 3.877-1.886 5.738-2.799 4.605-2.239 9.202-4.508 13.815-6.736 2.495-1.205 5.073.244 5.285 2.994.113 1.47-.542 2.644-1.877 3.321-2.18 1.107-4.386 2.16-6.578 3.237-.207.102-.41.211-.7.361 1.053.782 1.731 1.74 1.82 3.023.088 1.284-.462 2.295-1.52 3.167 1.107.7 1.806 1.657 1.903 2.94.097 1.281-.411 2.31-1.311 3.087.505.618 1.097 1.143 1.433 1.798.91 1.775.157 3.852-1.696 4.786-2.182 1.102-4.39 2.156-6.588 3.228-2.26 1.103-4.515 2.217-6.785 3.298-4.026 1.92-8.453.42-10.428-3.58-1.12-2.253-2.278-4.498-3.166-6.84-1.11-2.93-.884-5.926.056-8.91 1.496-4.747 2.907-9.517 4.339-14.288.3-1.003.536-2.025.831-3.03a3.459 3.459 0 014.216-2.414c1.797.44 2.871 2.207 2.576 4.074-.479 3.033-.894 6.073-1.363 9.283zm1.617 12.799a3.307 3.307 0 00-.299-.148c-1.581-.569-2.435-1.745-2.502-3.368-.064-1.588.763-2.705 2.22-3.403 3.339-1.6 6.656-3.246 9.981-4.872l11.107-5.433c1.007-.495 1.462-1.429 1.198-2.404-.409-1.515-1.731-2.07-3.241-1.334a13931.55 13931.55 0 00-20.217 9.865c-.396.192-.858.526-1.202.102-.217-.267-.266-.768-.215-1.14.468-3.438.98-6.866 1.468-10.3.166-1.186-.48-2.086-1.61-2.323-1.065-.222-2.046.42-2.36 1.558-.28 1.031-.533 2.074-.84 3.099-1.4 4.633-2.728 9.285-4.228 13.884-1.087 3.33-1.078 6.539.41 9.715a254.3 254.3 0 002.596 5.343c1.2 2.414 3.855 3.864 6.49 3.315 1.34-.28 2.591-.98 3.875-1.518.48-.2.934-.463 1.468-.73-1.776-1.26-2.227-2.854-1.54-4.77-2.024-.694-3.408-2.343-2.56-5.138zm-1.329-3.927c-.022 1.941 1.57 2.97 3.106 2.228 3.77-1.825 7.534-3.663 11.291-5.514 1.275-.626 1.69-1.762 1.106-2.94-.551-1.119-1.738-1.48-2.968-.89-.924.443-1.837.906-2.756 1.355a3535.642 3535.642 0 01-8.411 4.094c-.822.392-1.341.976-1.368 1.667zm16.123 1.15c0-1.792-1.563-2.834-3-2.154a534.513 534.513 0 00-9.404 4.585c-1.12.56-1.493 1.757-.98 2.843a2.112 2.112 0 002.858.959c3.122-1.5 6.234-3.026 9.342-4.555.784-.389 1.16-1.046 1.184-1.678zm-8.77 11.597c.215-.022.425-.074.625-.154 2.536-1.223 5.077-2.434 7.585-3.71 1.013-.515 1.321-1.762.82-2.788-.464-.95-1.615-1.482-2.597-1.024a220.515 220.515 0 00-7.777 3.798c-.849.432-1.15 1.478-.872 2.368.295.94 1.068 1.517 2.217 1.51z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_299_426",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H36.249V40H0z",
                        transform: "translate(28 25)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var hand = (Hand);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/contentintelligence/whyUs/index.tsx







const whyUsList = [
    {
        description: "Facilitate the easy, smooth flow of critical information across the company or organization.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hand, {})
    },
    {
        description: "Save time by speeding up your workflow and have access to your documents at all times.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(watch, {})
    },
    {
        description: "It can also help you collect, store, and organize your files and data in one place so that you can keep tracking it.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(box, {})
    }, 
];
function WhyUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: whyUsList,
        mainTitle: "Why Do You Need Content Intelligence?",
        colors: {
            descriptionColor: (compareCRMPricesVariables_module_default()).whyUsItemBrief
        },
        classes: {
            mainTitleClasses: "text-center font-bold text-xl lg:text-4xl mb-14",
            innerSectionClasses: "lg:flex flex-wrap justify-center",
            oneBoxClasses: "text-center mb-12 lg:mb-20 w-full lg:w-1/3",
            iconClasses: "children:mx-auto",
            descriptionClasses: "font-light text-sm text-center w-4/5 mx-auto mt-2"
        }
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);